import { createSelector } from '@reduxjs/toolkit';

import { assertExhaustiveSwitch } from '@paragon/utilities';

import { RootState } from '../../index';

const getAllCameraProperties = (state: RootState) => state.camera.properties;
export const getCurrentRenderMode = (state: RootState) => state.camera.mode;

export const getCurrentCameraType = createSelector(
  (state: RootState) => state.camera.mode,
  (state: RootState) => state.camera.activeDesignCamera,
  (state: RootState) => state.camera.activeLayoutCamera,

  (mode, designCameraType, layoutCameraType) => {
    switch (mode) {
      case 'design':
        return designCameraType;

      case 'layout':
        return layoutCameraType;

      default:
        assertExhaustiveSwitch(mode);
    }
  },
);

export const getCurrentCameraTypeAndProperties = createSelector(
  getCurrentCameraType,
  getAllCameraProperties,
  (activeCameraType, cameraProperties) => [activeCameraType, cameraProperties[activeCameraType]] as const,
);
